var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVamarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.25 8C10.216 8 11 6.545 11 4.75S10.216 1.5 9.25 1.5m0 6.5C8.284 8 7.5 6.545 7.5 4.75S8.284 1.5 9.25 1.5m0 6.5L2.722 6.813c-.464-.084-.696-.126-.883-.219a1.5 1.5 0 0 1-.782-.936C1 5.457 1 5.221 1 4.75c0-.471 0-.707.057-.908a1.5 1.5 0 0 1 .782-.936c.187-.093.419-.135.883-.22L9.25 1.501M2.5 7l.197 2.757c.019.262.028.393.085.492a.5.5 0 0 0 .216.201c.103.05.234.05.497.05h.891c.3 0 .45 0 .561-.06a.5.5 0 0 0 .22-.237c.051-.116.04-.265.017-.564L5 7.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVamarketing);
export default __webpack_public_path__ + "static/media/vamarketing.095986dc43f60d852070be8e93f76c9e.svg";
export { ForwardRef as ReactComponent };